import { Font } from '@react-pdf/renderer';

let fontsRegistered = false;

/**
 * Registers PDF fonts for React-PDF documents
 * This function ensures fonts are registered only once to prevent duplicates
 * and improve performance across all PDF components
 */
export const registerPdfFonts = (): void => {
    if (fontsRegistered) {
        return; // Prevent duplicate registrations
    }

    try {
        // Registra DejaVu Sans per supporto Unicode pedici
        Font.register({
            family: 'DejaVuSans',
            src: '/fonts/DejaVuSans.ttf',
            fontWeight: 'normal',
        });

        Font.register({
            family: 'DejaVuSans',
            src: '/fonts/DejaVuSans-Bold.ttf',
            fontWeight: 'bold',
        });

        fontsRegistered = true;
    } catch (error) {}
};

/**
 * Ensures fonts are registered before PDF generation
 * Call this function at the beginning of any PDF component
 */
export const ensureFontsRegistered = (): void => {
    if (!fontsRegistered) {
        registerPdfFonts();
    }
};

/**
 * Reset font registration state (for testing purposes)
 */
export const resetFontRegistration = (): void => {
    fontsRegistered = false;
};

/**
 * Check if fonts are already registered
 */
export const areFontsRegistered = (): boolean => {
    return fontsRegistered;
};
